import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import "./../styles/ecom.css";
import "./../styles/ecom/productos.css";
import * as globals from "./../components/GlobalScripts.js";
import NavbarTop from "./ecom/Navbartop";
import Footer from "./ecom/Footer";

const Productos = () => {
    const path_api = localStorage.getItem("path_api");
    const { id } = useParams();
    const [producto, setProducto] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedTalla, setSelectedTalla] = useState(null);
    const [cantidad, setCantidad] = useState(1);
    const [mainImage, setMainImage] = useState(null);
    const [retryCount, setRetryCount] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchFacebookData = async () => {
            let facebookParams = globals.facebookParams();
            let event_source_url = facebookParams.event_source_url;
            let client_user_agent = facebookParams.client_user_agent;
            let event_time = facebookParams.event_time;
            let facebookPixel = facebookParams.facebookPixel;
            let facebookToken = facebookParams.facebookToken;
            let event_id = facebookParams.event_id;

            let data = {
                "event_source_url": event_source_url,
                "event_time": event_time,
                "client_user_agent": client_user_agent,
                "hostedBy": "Zadrig"
            };

            await window.fbq('track', 'PageView', data, { eventID: event_id });

            let fbp = facebookParams.fbp;
            let fbc = facebookParams.fbc;

            await fetch('https://zadrig.com/facebook/eventos/ecommerce.zadrigman/pageview.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    event_id: event_id,
                    facebookPixel: facebookPixel,
                    facebookToken: facebookToken,
                    event_time: event_time,
                    fbp: fbp,
                    fbc: fbc,
                    event_source_url: event_source_url,
                    client_user_agent: client_user_agent
                }),
            });
        };

        fetchFacebookData();
    }, [id]);

    useEffect(() => {
        get_producto();
    }, [id, retryCount]);

    const get_producto = async () => {
        if (loading || retryCount > 4) return;

        setLoading(true);
        await axios
            .post(`${path_api}/ecom/producto.php`, {
                rute: globals.getRuteBackend(),
                producto: id,
            })
            .then((response) => {
                if (response.data.mensaje === "success") {
                    const data = JSON.parse(response.data.producto.data);
                    const categorias = JSON.parse(response.data.producto.categorias || "[]");
                    const etiquetas = JSON.parse(response.data.producto.etiquetas || "[]");

                    setProducto({
                        ...response.data.producto,
                        ...data,
                        categorias,
                        etiquetas,
                    });
                    setSelectedTalla(data.variaciones[0].talla);
                    setSelectedColor(data.variaciones[0].color);
                    setMainImage(data.imagenes[0].url);
                    setRetryCount(5);
                } else {
                    if (retryCount < 4) {
                        setTimeout(() => setRetryCount(retryCount + 1), 2000);
                    } else {
                        setRetryCount(retryCount + 1);
                        // globals.createAlert({
                        //     type: "error",
                        //     msg_title: "Error",
                        //     msg: response.data.mensaje || "No se obtuvo el producto",
                        //     effect: "opacidad 2s, desplazamiento 2s",
                        //     time_life: 4000,
                        // });
                    }
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-productos-1'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
                setRetryCount(3);
            }).finally(() => {
                setLoading(false);
            });
    };

    const handleAddToCart = async () => {
        const selectedVariant = producto?.variaciones.find(
            (v) => v.color === selectedColor && v.talla === selectedTalla
        );

        if (!selectedVariant) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "No se pudo agregar al carrito",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000,
            });
            return;
        }

        const carritoActual = JSON.parse(localStorage.getItem("carrito")) || [];
        const itemExistenteIndex = carritoActual.findIndex(
            (item) =>
                item.id === producto.id &&
                item.color === selectedColor &&
                item.talla === selectedTalla
        );

        if (itemExistenteIndex > -1) {
            carritoActual[itemExistenteIndex].cantidad += cantidad;
        } else {
            carritoActual.push({
                id: producto.id,
                nombre: producto.nombre,
                imagen: mainImage,
                color: selectedColor,
                talla: selectedTalla,
                cantidad,
                precio: selectedVariant.precio,
                envio: producto.envio,
            });
        }

        let facebookParams = globals.facebookParams();
        let event_source_url = facebookParams.event_source_url;
        let client_user_agent = facebookParams.client_user_agent;
        let event_time = facebookParams.event_time;
        let facebookPixel = facebookParams.facebookPixel;
        let facebookToken = facebookParams.facebookToken;
        let event_id = facebookParams.event_id;

        let data = {
            "event_source_url": event_source_url,
            "event_time": event_time,
            "client_user_agent": client_user_agent,
            "content_name": producto.nombre,
            "value": selectedVariant.precio,
            "currency": 'MXN',
            "hostedBy": "Zadrig"
        };

        await window.fbq('track', 'AddToCart', data, { eventID: event_id });

        let fbp = facebookParams.fbp;
        let fbc = facebookParams.fbc;

        await fetch('https://zadrig.com/facebook/eventos/ecommerce.zadrigman/add_to_cart.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                event_id: event_id,
                facebookPixel: facebookPixel,
                facebookToken: facebookToken,
                event_time: event_time,
                fbp: fbp,
                fbc: fbc,
                event_source_url: event_source_url,
                client_user_agent: client_user_agent,
                producto: producto.nombre,
                precio: selectedVariant.precio,
                divisa: 'MXN',
            }),
        });

        localStorage.setItem("carrito", JSON.stringify(carritoActual));

        globals.createAlert({
            type: "success",
            msg_title: "Añadido",
            msg: "Producto agregado al carrito",
            effect: "opacidad 2s, desplazamiento 2s",
            time_life: 4000,
        });
    };

    const getFilteredColors = () => {
        return producto.variaciones
            .filter((variante) => variante.talla === selectedTalla)
            .map((variante) => variante.color)
            .filter((color, index, self) => self.indexOf(color) === index);
    };

    const selectedVariant = producto?.variaciones.find(
        (v) => v.color === selectedColor && v.talla === selectedTalla
    );

    const handleTallaChange = (talla) => {
        setSelectedTalla(talla);

        const coloresDisponibles = producto.variaciones
            .filter((variante) => variante.talla === talla)
            .map((variante) => variante.color);

        if (coloresDisponibles.length > 0) {
            setSelectedColor(coloresDisponibles[0]);
        }
    };

    const reintentar_back = () => {
        setRetryCount(0);
    }

    if (retryCount < 5) {
        return (
            <div className="app-ecom app-container">
                <div className="main-content page-producto">
                    <div className="page-container flex-row gap-40">
                        <p>Estamos cargando el producto, por favor espera un momento...</p>
                        {retryCount > 0 && (
                            <p>Reintentando cargar los datos (Intento {retryCount + 1} de 5)...</p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    if (!producto) {
        return (
            <div className="app-ecom app-container">
                <div className="main-content page-producto">
                    <div className="page-container flex-row gap-40">
                        <h2>No se obtuvo el producto.</h2>
                        <button className="button-primary" onClick={reintentar_back}>
                            Reintentar
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="app-ecom app-container">
            <NavbarTop />
            <div className="main-content page-producto">
                <div className="page-container flex-row gap-40">
                    <div className="container-section flex-row gap-20 margin-top">
                        <div className="product-gallery" style={{ maxWidth: "500px" }}>
                            <div className="main-image">
                                <img src={mainImage} alt={producto.nombre} />
                            </div>
                            <div className="thumbnail-gallery">
                                {producto.imagenes.map((img, index) => (
                                    <img
                                        key={index}
                                        src={img.url}
                                        alt={`Thumbnail ${index}`}
                                        onClick={() => setMainImage(img.url)}
                                        className={mainImage === img.url ? "active" : ""}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className="product-details">
                            <h1>{producto.nombre}</h1>
                            {producto.descripcion && (
                                <p className="product-descripcion">
                                    <b style={{ fontSize: "var(--font-size-h4)" }}>Descripcion:</b>
                                    <br />
                                    {producto.descripcion.split("\n").map((line, index) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </p>
                            )}
                            {producto.proveedor && (
                                <p className="product-provider">Proveedor: {producto.proveedor}</p>
                            )}

                            <div className="product-options">
                                <div className="flex-column sizes gap-10">
                                    <h5>Talla</h5>
                                    <div className="size-options">
                                        {producto.variaciones
                                            .map((variante) => variante.talla)
                                            .filter((talla, index, self) => self.indexOf(talla) === index)
                                            .map((talla, index) => (
                                                <button
                                                    key={index}
                                                    className={`size-option ${selectedTalla === talla ? "active" : ""}`}
                                                    onClick={() => handleTallaChange(talla)}
                                                >
                                                    {talla}
                                                </button>
                                            ))}
                                    </div>
                                </div>

                                <div className="flex-column colors gap-10">
                                    <h5>Color</h5>
                                    <p className="selected-variant">
                                        Seleccionado: {selectedColor}
                                    </p>
                                    <div className="color-options">
                                        {getFilteredColors().map((color, index) => (
                                            <button
                                                key={index}
                                                className={`color-option ${selectedColor === color ? "active" : ""
                                                    }`}
                                                style={{
                                                    backgroundColor: producto.variaciones.find(
                                                        (v) => v.color === color
                                                    ).code,
                                                }}
                                                onClick={() => setSelectedColor(color)}
                                            ></button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <h3 className="product-price">${selectedVariant?.precio} MXN</h3>
                            <p className="product-inventory">
                                {selectedVariant?.ilimitado ? (
                                    <span>
                                        Inventario: <b style={{ color: "var(--color-green)" }}>ilimitado</b>
                                    </span>
                                ) : (
                                    <span>
                                        Inventario:{" "}
                                        <b
                                            style={{
                                                color:
                                                    selectedVariant?.inventario === 0
                                                        ? "var(--color-red)"
                                                        : "inherit",
                                            }}
                                        >
                                            {selectedVariant?.inventario || 0}
                                        </b>
                                    </span>
                                )}
                            </p>

                            <p className="product-shipping">Envío: {producto.envio}</p>

                            <div className="quantity">
                                <button
                                    onClick={() =>
                                        setCantidad(cantidad > 1 ? cantidad - 1 : 1)
                                    }
                                    disabled={!selectedVariant?.ilimitado && cantidad <= 1}
                                >
                                    -
                                </button>
                                <input type="text" value={cantidad} readOnly />
                                <button
                                    onClick={() => setCantidad(cantidad + 1)}
                                    disabled={
                                        !selectedVariant?.ilimitado &&
                                        cantidad >= selectedVariant?.inventario
                                    }
                                >
                                    +
                                </button>
                            </div>

                            {selectedVariant?.ilimitado || selectedVariant?.inventario > 0 ? (
                                <button className="button-primary" onClick={handleAddToCart}>
                                    Agregar al carrito
                                </button>
                            ) : (
                                <p
                                    className="no-stock-message"
                                    style={{ color: "var(--color-red)", fontWeight: "bold" }}
                                >
                                    No hay inventario disponible
                                </p>
                            )}

                            <div className="product-categories">
                                <h4>Categorías:</h4>
                                {producto.categorias && producto.categorias.length > 0 ? (
                                    producto.categorias.map((categoria, index) => (
                                        <Link
                                            key={index}
                                            to={`/categorias/${categoria}`}
                                            className="category-link"
                                        >
                                            {categoria}
                                        </Link>
                                    ))
                                ) : (
                                    <p>No hay categorías disponibles</p>
                                )}
                            </div>

                            <div className="product-tags">
                                <h4>Etiquetas:</h4>
                                {producto.etiquetas && producto.etiquetas.length > 0 ? (
                                    producto.etiquetas.map((etiqueta, index) => (
                                        <Link
                                            key={index}
                                            to={`/colecciones/${etiqueta}`}
                                            className="tag-link"
                                        >
                                            {etiqueta}
                                        </Link>
                                    ))
                                ) : (
                                    <p>No hay etiquetas disponibles</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Productos;
